import React from "react";
import OperatorListComponent from "../../components/manager/users/operators/OperatorListComponent";
import DashboardLayout from "../../components/layouts/DashboardLayout";
const OperatorListSA = ({ department }) => {

  return (
    <DashboardLayout
    >
      <OperatorListComponent
        department={department}
        internalUserType="operator"
      />
    </DashboardLayout>
  );
};

export default OperatorListSA;
